import { useQuery } from 'hooks/useCustomQuery';
import getSRTTrunk from 'API/SRT/getSRTTrunk';

/**
 * The SRT trunk being edited.
 *
 * Skipped in add mode, where there is no trunk yet. Creating one navigates to
 * the edit route without remounting this page, so the id changing is what
 * triggers the fetch.
 *
 * @param {object}   params
 * @param {string}   params.id
 * @param {boolean}  [params.enabled]
 * @param {function} params.onSuccess Receives the trunk.
 * @param {function} [params.onError]
 */
const useGetSRTTrunk = ({ id, enabled = true, onSuccess, onError }) =>
    useQuery({
        queryKey: ['srtTrunk', id],
        queryFn: async () => {
            const res = await getSRTTrunk(id);
            return res.data;
        },
        enabled: Boolean(id) && enabled,
        onSuccess,
        onError,
    });

export default useGetSRTTrunk;
